module.exports = __webpack_public_path__ + "media/images/landkit/photos/photo-26-e96ded592615bae7b08ad4d1db9cbfd9.jpg";